<template>
  <v-text-field
    v-model="model"
    v-mask="'########'"
    dense
    outlined
    :placeholder="placeholder"
    :label="label"
    :rules="[rules.required]"
  />
</template>

<script>
// @input="searchZipCode"
import { Subject, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap
} from "rxjs/operators";
import enderecoService from '@/services/sit-pedidos/endereco.service'

export default {
  name: 'ZipCodeField',

  props: {
    label: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      required: true,
    },

    value: {
      type: String,
      default: ()=>(null),
    },
  },

  data: () => ({
    zipCodeService: null,

    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    }
  }),

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  mounted(){
    this.zipCodeSubject()
  },

  methods: {
    searchZipCode(value) {
      this.zipCodeService.next(value);
    },

    zipCodeSubject() {
      // this.zipCodeService = new Subject();
      // this.zipCodeService
      //   .pipe(
      //     tap(value => {
      //       console.log(value)
      //     })
      //   )
      //   .pipe(debounceTime(800))
      //   .pipe(distinctUntilChanged())
      //   .pipe(switchMap(value => enderecoService.findByZipCode(value)))
      //   .subscribe((res)=>{
      //     console.log(res)
      //   }, (err) => {
      //     console.log(err)
      //   })
    },
  }
}
</script>
